import * as Sentry from 'sentry-expo';
import { isWebPlatform } from './PlatformDevice';
export const captureException = (error: any) => {
    if (isWebPlatform() || __DEV__) {
        return;
    }
    return Sentry.Native.captureException(error);
}